import clsx from 'clsx';
import { useCallback, useRef, useState } from 'react';
import { useOnViewport } from '@/components/core/hooks';
import { UIComponent } from '../..';
import * as styles from './animate-on-viewport.styles';

const AnimateOnViewport: UIComponent<{ type?: 'right' | 'left' | 'grow' }> = ({ children, as: Component = 'section', className, type, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  const onViewport = useCallback((isOnViewport) => {
    setIsVisible(isOnViewport);
  }, []);

  useOnViewport(ref, onViewport, { disabled: isVisible, options: { threshold: 0.25 } });

  return (
    <Component
      ref={ref}
      className={clsx(className, styles.root, styles[type as any], {
        [styles.viewport]: isVisible,
      })}
      {...props}
    >
      {children}
    </Component>
  );
};

export default AnimateOnViewport;
